/**
 * Cottolio PDP gallery — isolated Swiper init.
 * Avoids global sliderInit destroy/reinit that can flash or swap slides.
 */
(function () {
	const GALLERY_SELECTOR = '.product-main-cottolio__gallery-outer';
	const RESIZE_DEBOUNCE_MS = 160;
	let resizeTimer = null;

	function syncThumbHeight(root) {
		const mainEl = root?.querySelector('.js-media-list');
		if (!mainEl) return;

		const mainHeight = Math.round(mainEl.getBoundingClientRect().height);
		if (mainHeight > 0) {
			root.style.setProperty('--cottolio-thumb-max-height', `${mainHeight}px`);
		}
	}

	function bindThumbWheel(subEl) {
		if (!subEl || subEl.dataset.cottolioWheelBound === 'true') return;

		subEl.addEventListener(
			'wheel',
			(event) => {
				if (!window.matchMedia('(min-width: 750px)').matches) return;

				const swiper = subEl.swiper;
				if (!swiper || swiper.isHorizontal()) return;

				const current = swiper.getTranslate();
				const minTranslate = swiper.maxTranslate();
				const maxTranslate = swiper.minTranslate();
				const next = Math.min(maxTranslate, Math.max(minTranslate, current - event.deltaY));

				event.preventDefault();
				event.stopPropagation();
				if (next === current) return;

				swiper.setTranslate(next);
				swiper.updateProgress(next);
				swiper.updateActiveIndex();
				swiper.updateSlidesClasses();
			},
			{ passive: false }
		);

		subEl.dataset.cottolioWheelBound = 'true';
	}

	function initGallery(root, force) {
		if (!root) return;

		const mainEl = root.querySelector('.js-media-list');
		const subEl = root.querySelector('.js-media-sublist');
		if (!mainEl || !subEl || typeof Swiper === 'undefined') return;

		if (root.dataset.cottolioGalleryInit === 'true' && !force) return;

		if (mainEl.swiper) mainEl.swiper.destroy(false, true);
		if (subEl.swiper) subEl.swiper.destroy(false, true);

		const isThumbsAside = subEl.classList.contains('sublist-thumbs-aside');
		const verticalBreakpoint = isThumbsAside ? 1100 : 990;

		const subSlider = new Swiper(subEl, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			direction: 'horizontal',
			freeMode: true,
			mousewheel: {
				forceToAxis: true,
				releaseOnEdges: true,
			},
			watchSlidesProgress: true,
			resistanceRatio: 0,
			observer: false,
			observeParents: false,
			updateOnWindowResize: false,
			breakpoints: {
				[verticalBreakpoint]: {
					spaceBetween: 0,
					direction: 'vertical',
					slidesPerView: 'auto',
				},
			},
		});

		new Swiper(mainEl, {
			slidesPerView: 1,
			spaceBetween: 0,
			autoHeight: false,
			speed: 280,
			effect: 'fade',
			fadeEffect: { crossFade: true },
			observer: false,
			observeParents: false,
			updateOnWindowResize: false,
			thumbs: { swiper: subSlider },
		});

		root.dataset.cottolioGalleryInit = 'true';
		bindThumbWheel(subEl);
		syncThumbHeight(root);
		requestAnimationFrame(() => {
			syncThumbHeight(root);
			if (subEl.swiper) subEl.swiper.update();
		});
	}

	function updateGalleries() {
		document.querySelectorAll(GALLERY_SELECTOR).forEach((root) => {
			const mainEl = root.querySelector('.js-media-list');
			const subEl = root.querySelector('.js-media-sublist');
			syncThumbHeight(root);
			if (mainEl?.swiper) mainEl.swiper.update();
			if (subEl?.swiper) subEl.swiper.update();
		});
	}

	function initAll(force) {
		document.querySelectorAll(GALLERY_SELECTOR).forEach((root) => initGallery(root, force));
	}

	window.initCottolioProductGallery = initAll;

	document.addEventListener('DOMContentLoaded', () => initAll(false));
	document.addEventListener('shopify:section:load', () => initAll(true));

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(updateGalleries, RESIZE_DEBOUNCE_MS);
	});
})();
